import { JsonDecoder } from 'ts.data.json';

import { OnlineAnalysisFilterValues } from '../Filter/Types';
import { AccountOnlineAnalysis } from '../MyLom/Account/EditAccount/Types';
import { Payload } from '../OnlineAnalysis/Types';

export function saveOnlineAnalysis(
    payload: Payload,
    onSuccess: (id: string) => void,
    onError?: (json: any) => void,
    onFailure?: (error: any) => void,
) {
    fetch(`/api/account/online-analysis`, {
        method: 'post',
        body: JSON.stringify(payload),
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors || !json.data) {
                console.error('Could not save online analysis');

                if (onError && typeof onError === 'function') {
                    onError(json);
                }
            } else if (json.data.id) {
                onSuccess(json.data.id);
            } else {
                if (onError && typeof onError === 'function') {
                    onError(json);
                }
            }
        })
        .catch((error) => {
            console.error('Server failure while saving online analysis', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}

export function deleteOnlineAnalysis(
    id: string,
    onSuccess: () => void,
    onError?: (json: any) => void,
    onFailure?: (error: any) => void,
) {
    fetch(`/api/account/online-analysis/${id}`, {
        method: 'delete',
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                console.error('Could not delete online analysis');

                if (onError && typeof onError === 'function') {
                    onError(json);
                }
            }
            onSuccess();
        })
        .catch((error) => {
            console.error('Server failure while saving online analysis', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}

export function getOnlineAnalysisResults(
    id: string,
    onSuccess: (id: AccountOnlineAnalysis) => void,
    onError?: (json: any) => void,
    onFailure?: (error: any) => void,
) {
    const OnlineAnalysisDecoder = JsonDecoder.object<AccountOnlineAnalysis>(
        {
            id: JsonDecoder.string,
            answers: JsonDecoder.object<OnlineAnalysisFilterValues>(
                {
                    ageGroup: JsonDecoder.nullable(JsonDecoder.string),
                    skinAppearance: JsonDecoder.nullable(JsonDecoder.string),
                    skinCharacteristics: JsonDecoder.array(JsonDecoder.string, 'string[]'),
                    skinColour: JsonDecoder.nullable(JsonDecoder.string),
                    uvSensitivity: JsonDecoder.nullable(JsonDecoder.string),
                },
                'Online Analysis Answers',
            ),
            creationDateTime: JsonDecoder.string.map((date) => new Date(date)),
        },
        'Online Analysis',
    );

    fetch(`/api/account/online-analysis/${id}`, {
        method: 'get',
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors || !json.data) {
                console.error('Could not read default online analysis');

                if (onError && typeof onError === 'function') {
                    onError(json);
                }
            } else if (json.data) {
                OnlineAnalysisDecoder.decodeToPromise(json.data)
                    .then((onlineAnalysis: AccountOnlineAnalysis) => {
                        onSuccess(onlineAnalysis);
                    })
                    .catch((error: string) => {
                        console.error(error);
                        if (onError && typeof onError === 'function') {
                            onError(error);
                        }
                    });
            } else {
                if (onError && typeof onError === 'function') {
                    onError(json);
                }
            }
        })
        .catch((error) => {
            console.error('Server failure while reading online analysis', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}
